export function isSubstring(str: string | any[], sub: string | any[]) {
  if (sub.length > str.length) return false;
  for (let i = 0; i < str.length - sub.length + 1; i++) {
    if (str[i] !== sub[0]) continue;
    let exists = true;
    for (let j = 1; j < sub.length && exists; j++) {
      if (str[i + j] === sub[j]) continue;
      exists = false;
    }
    if (exists) return true;
  }
  return false;
}
